import styled, { css } from "styled-components";
import { StickyHeader } from "./Header";
import { outerContainerCss } from "../constants/styles";

const UnnamedComponent = styled.div`
  ${outerContainerCss};

  ${StickyHeader} + & {
    min-height: calc(100vh - 130px);
  }

  ${(props) =>
    props.$paddingY &&
    css`
      padding-top: 50px;
      padding-bottom: 50px;
    `};

  ${(props) =>
    props.$borderTop &&
    css`
      border-top: 1px solid white;
    `};
`;

export const SectionTitle = styled.h1``;

export const SectionSeparator = styled.div`
  background: linear-gradient(to right, #bababa, #a86d00, #515151) border-box;
  height: 1.5px;
`;

export default UnnamedComponent;
